import * as React from 'react';
import { useAuth } from '../../../App';
import { PaginationNavigation, SpinnerWrapper, SortTableContext } from "soprasteria-ui-library";
import { IPagination } from "soprasteria-ui-library/dist/models/IPagination";
import { isInRole, UserContext } from "../../../contexts/UserContext";
import { LIBRETTOADMIN, VÅRDANSVARIG } from '../../../utils/RoleConstants';
import { IEndedListingPatient, ISearchEndedListing } from "../../../models/IEndedListingPatient"
import { ListingsApi } from '../../../api/ListingsApi';
import { ListingsEndedTable } from "./ListingsEndedTable";
import { useHistory } from 'react-router';
import { formatDate } from '../../../helpers/DateHelper';
import { setMessage } from '../../../helpers/MessageHelper';
import { ListingsEndedSearchForm } from './ListingsEndedSearchForm';
import { ENDED_LISTINGS } from '../../../utils/RouteConstants';

export const ListingsEnded: React.FunctionComponent<{}> = () => {

    const auth = useAuth();
    const listingApi = new ListingsApi(auth);
    const userInfo = React.useContext(UserContext);
    const history = useHistory();

    const [tableData, setTableData] = React.useState<IEndedListingPatient[]>();
    const [isFetchingEndedListings, setIsFetchingEndedListings] = React.useState<boolean>(false);
    const [isExportingToExcel, setIsExportingToExcel] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>();
    const [paginationHeader, setPaginationHeader] = React.useState<IPagination>();
    const hasRoleParaply = isInRole(VÅRDANSVARIG, userInfo.roles);
    const hasRoleSysAdmin = isInRole(LIBRETTOADMIN, userInfo.roles);
    const pageNumber = 1;
    const pageSize = 20;
    const [searchParams, setSearchParams] = React.useState<ISearchEndedListing>({ pageNumber: pageNumber, pageSize: pageSize });
    const { sortOrder, selectedPropertyToSortBy, setSelectedPropertyToSortBy, setSortOrder } = React.useContext(SortTableContext);
    const [isFirstSearch, setIsFirstSearch] = React.useState<boolean>(true);

    React.useEffect(() => {
        if (!isFirstSearch) {
            onSortOrderClick();
        }
    }, [selectedPropertyToSortBy, sortOrder])

    const getEndedListings = (data: ISearchEndedListing) => {
        if ((hasRoleParaply || hasRoleSysAdmin) && data.careProviderId !== undefined || !hasRoleParaply) {
            setIsFetchingEndedListings(true);
            if (setSelectedPropertyToSortBy && setSortOrder) {
                if (isFirstSearch) {
                    setSelectedPropertyToSortBy(data.propertyToOrderBy);
                    if (data?.sortOrder) {
                        setSortOrder(data.sortOrder);
                    }
                }
                else {
                    setIsFirstSearch(true);
                    setSelectedPropertyToSortBy(undefined);
                }
            }
            data.pageSize = pageSize;
            data.pageNumber = data.pageNumber ?? 1;
            history.push(ENDED_LISTINGS, data);

            listingApi.getEndedListings(data, (response) => {
                setTableData(response.data);
                setPaginationHeader(response.paginationHeader);
            }, (message) => {
                const newMessage = setMessage(message, errorMessage ?? "");
                setErrorMessage(newMessage);
            }, () => setIsFetchingEndedListings(false));
        }
        setSearchParams(data);
        setIsFirstSearch(false);
    }

    const endedListingsToExcelSubmit = (params: ISearchEndedListing) => {
        setIsExportingToExcel(true);
        listingApi.getEndedListingsAsExcel(params,
            `Avlistade patienter ${formatDate()}`,
            () => { },
            () => { },
            () => {
                setIsExportingToExcel(false);
            }
        );
    }

    const onPageSelect = (page: number) => {
        if (searchParams) {
            setIsFetchingEndedListings(true);
            var currentSearchParams = searchParams;
            currentSearchParams.pageNumber = page;
            history.push(ENDED_LISTINGS, currentSearchParams);

            listingApi.getEndedListings(currentSearchParams, (response) => {
                setTableData(response.data);
                setPaginationHeader(response.paginationHeader);
            }, undefined, () => setIsFetchingEndedListings(false));
        }
    }

    const onSortOrderClick = () => {
        if (searchParams) {
            setIsFetchingEndedListings(true);
            var currentSearchParams = searchParams;
            currentSearchParams.pageNumber = 1;
            currentSearchParams.sortOrder = sortOrder;
            currentSearchParams.propertyToOrderBy = selectedPropertyToSortBy;
            history.push(ENDED_LISTINGS, currentSearchParams);

            listingApi.getEndedListings(currentSearchParams, (response) => {
                setTableData(response.data);
                setPaginationHeader(response.paginationHeader);
            }, undefined, () => setIsFetchingEndedListings(false));
        }
    }

    return (
        <SpinnerWrapper isLoading={isFetchingEndedListings}>
            <section className="card">
                <div className="card-header">
                    <h2>Avlistade patienter</h2>
                </div>
                <div className="card-body">
                    <ListingsEndedSearchForm searchEndedListings={getEndedListings} isParaply={hasRoleParaply} isSysAdmin={hasRoleSysAdmin} exportToExcel={endedListingsToExcelSubmit} isExportingToExcel={isExportingToExcel} preSetSearchParams={history.location.state !== undefined && history.location.state !== null ? history.location.state as any : undefined} />
                    <ListingsEndedTable id="endedlisting-table" data={tableData} />
                    <PaginationNavigation
                        ariaLabel="ended listings on patients pagination selector"
                        pagination={paginationHeader}
                        pageNeighbours={2}
                        selectedPage={page => onPageSelect(page)}
                        showCount={true} />
                </div>
            </section>
        </SpinnerWrapper>
    )
}